import { useCallback, useState, useMemo } from 'react';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import ErrorBoundary from 'customer-data-objects-ui-components/ErrorBoundary';
import UniversalAssociationsSelectSearchPaneError from './UniversalAssociationsSelectSearchPaneError';
import UniversalAssociationsSelectSearchResults from './UniversalAssociationsSelectSearchResults';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../h... Remove this comment to see the full error message
import { useDebounce } from '../hooks/useDebounce';
import unescapedText from 'I18n/utils/unescapedText';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../h... Remove this comment to see the full error message
import * as FilterAssociationsHelper from '../helpers/FilterAssociationsHelper';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ConnectReferenceResolvers from 'reference-resolvers/ConnectReferenceResolvers';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message

import SearchResultsReferenceResolverWrapper from './SearchResultsReferenceResolverWrapper';
import { ScreenReaderOnly } from 'foundations-components/transitional/components/ScreenReaderOnly';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { NOTE, TASK, LOGGED_CALL, LOGGED_EMAIL, LOGGED_MEETING, LOGGED_LINKED_IN_MESSAGE, LOGGED_POSTAL_MAIL, LOGGED_SMS, LOGGED_WHATS_APP } from 'customer-data-objects/interaction/InteractionTypes';
import * as EngagementTypes from 'customer-data-objects/engagement/EngagementTypes';
import { ShinySkeletonText } from '../helpers/ShinySkeletonText';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PERMISSIONLESS_ACTIVITIES = [LOGGED_CALL, LOGGED_EMAIL, LOGGED_LINKED_IN_MESSAGE, LOGGED_POSTAL_MAIL, LOGGED_MEETING, LOGGED_SMS, LOGGED_WHATS_APP, NOTE, TASK, EngagementTypes.NOTE, EngagementTypes.TASK];
export const SearchPaneSkeleton = ({
  isSingleObjectType
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    inlineSize: "100%",
    flexDirection: "column",
    "data-test-id": "search-pane-skeleton",
    children: [/*#__PURE__*/_jsx(View, {
      as: "div",
      padding: "200",
      children: /*#__PURE__*/_jsx(SearchInput, {
        placeholder: "",
        use: "on-dark",
        disabled: true
      })
    }), /*#__PURE__*/_jsx(View, {
      as: "div",
      paddingBlockEnd: "200",
      paddingInline: "200",
      marginBlockStart: "100",
      overflowY: "scroll",
      children: Array.from({
        length: 2
      }, (_, index) => /*#__PURE__*/_jsxs("div", {
        children: [!isSingleObjectType && /*#__PURE__*/_jsx(ShinySkeletonText, {}), /*#__PURE__*/_jsx(Checkbox, {
          alignment: "center",
          checked: true,
          readOnly: true,
          marginBlockEnd: "200",
          children: /*#__PURE__*/_jsx(ShinySkeletonText, {})
        })]
      }, index))
    })]
  });
};
const UniversalAssociationsSelectSearchPane = ({
  associationRecords,
  canEdit,
  currentUserCanCommunicateWithEngagement = true,
  emailRecipientsIds,
  engagementOrInteractionType,
  onToggleSelectAssociation,
  readOnly,
  resolver,
  selectedObjectTypeId,
  shouldDisableLastAssociation,
  shouldShowPopoverOpenMessage,
  displayAllAssociations,
  setShouldShowPopoverOpenMessage,
  OptionWrapperComponent
}) => {
  const [searchText, setSearchText] = useState('');
  const [refetchKey, setRefetchKey] = useState(0);
  const debouncedSearch = useDebounce(searchText);
  const handleSearch = useCallback(({
    target: {
      value
    }
  }) => {
    setSearchText(value);
  }, [setSearchText]);
  const selectedAssociationRecord = useMemo(() => {
    if (!selectedObjectTypeId) {
      return associationRecords;
    }
    return associationRecords.find(associationRecord => associationRecord.get('toObjectTypeId') === selectedObjectTypeId);
  }, [selectedObjectTypeId, associationRecords]);
  const refetchOptions = useCallback(() => {
    setRefetchKey(refetchKey + 1);
  }, [refetchKey, setRefetchKey]);
  const AssociationOptions = useMemo(() => {
    if (selectedObjectTypeId) {
      return /*#__PURE__*/_jsx(SearchResultsReferenceResolverWrapper, {
        canEdit: canEdit,
        emailRecipientsIds: emailRecipientsIds,
        engagementOrInteractionType: engagementOrInteractionType,
        isSearching: !!debouncedSearch,
        onToggleSelectAssociation: onToggleSelectAssociation,
        readOnly: readOnly,
        resolver: resolver,
        searchText: debouncedSearch,
        selectedAssociationRecord: selectedAssociationRecord,
        selectedObjectTypeId: selectedObjectTypeId,
        shouldDisableLastAssociation: shouldDisableLastAssociation,
        OptionWrapperComponent: OptionWrapperComponent,
        refetchOptions: refetchOptions
      }, refetchKey);
    }
    const searchResults = FilterAssociationsHelper.filterAssociations(associationRecords, debouncedSearch, displayAllAssociations);
    return /*#__PURE__*/_jsx(UniversalAssociationsSelectSearchResults, {
      canEdit: canEdit,
      emailRecipientsIds: emailRecipientsIds,
      engagementOrInteractionType: engagementOrInteractionType,
      isSearching: !!debouncedSearch,
      onToggleSelectAssociation: onToggleSelectAssociation,
      readOnly: readOnly,
      searchResults: searchResults,
      searchText: searchText,
      shouldDisableLastAssociation: shouldDisableLastAssociation,
      OptionWrapperComponent: OptionWrapperComponent,
      refetchOptions: refetchOptions
    });
  }, [associationRecords, canEdit, debouncedSearch, emailRecipientsIds, engagementOrInteractionType, onToggleSelectAssociation, readOnly, resolver, searchText, selectedAssociationRecord, selectedObjectTypeId, shouldDisableLastAssociation, displayAllAssociations, OptionWrapperComponent, refetchKey, refetchOptions]);
  const pluralObjectName = useMemo(() => {
    return selectedObjectTypeId ? selectedAssociationRecord.get('pluralObjectName') : unescapedText('universalAssociationsSelect.associations');
  }, [selectedAssociationRecord, selectedObjectTypeId]);
  const placeholder = useMemo(() => {
    if (!selectedObjectTypeId) {
      return unescapedText('universalAssociationsSelect.searchPane.placeholder.currentAssociations');
    }
    return unescapedText('universalAssociationsSelect.searchPane.placeholder.selectedObject', {
      pluralObjectName
    });
  }, [pluralObjectName, selectedObjectTypeId]);
  const renderedAccessibilityHeader = useMemo(() => {
    if (searchText) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "universalAssociationsSelect.accessibility.searchResults"
      });
    }
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "universalAssociationsSelect.accessibility.objects",
      options: {
        pluralObjectName
      }
    });
  }, [pluralObjectName, searchText]);
  const isPermissionlessActivity = PERMISSIONLESS_ACTIVITIES.includes(engagementOrInteractionType);
  const shouldEnableSearch = isPermissionlessActivity || currentUserCanCommunicateWithEngagement;
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    boundaryName: "UniversalAssociationsSelectSearchPaneError",
    ErrorComponent: UniversalAssociationsSelectSearchPaneError,
    children: /*#__PURE__*/_jsxs(Flex, {
      inlineSize: "100%",
      flexDirection: "column",
      "data-test-id": "search-pane-skeleton",
      children: [/*#__PURE__*/_jsx(Tooltip, {
        disabled: shouldEnableSearch,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "universalAssociationsSelect.tooltipCommunicationPermissionErrorV2"
        }),
        children: /*#__PURE__*/_jsxs(View, {
          as: "div",
          padding: "200",
          children: [/*#__PURE__*/_jsx(SearchInput, {
            "aria-describedby": `universal-associations-select-search-${selectedObjectTypeId}`,
            autoFocus: true,
            "data-selenium-test": "association-search",
            disabled: !shouldEnableSearch,
            onChange: handleSearch,
            placeholder: placeholder,
            use: "on-dark",
            onBlur: () => {
              if (setShouldShowPopoverOpenMessage) {
                setShouldShowPopoverOpenMessage(false);
              }
            },
            value: searchText
          }), /*#__PURE__*/_jsxs(ScreenReaderOnly, {
            children: [/*#__PURE__*/_jsx("div", {
              id: `universal-associations-select-search-${selectedObjectTypeId}`,
              children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                message: shouldShowPopoverOpenMessage ? 'universalAssociationsSelect.accessibility.popoverOpened' : 'universalAssociationsSelect.accessibility.search',
                options: {
                  pluralObjectName
                }
              })
            }), /*#__PURE__*/_jsx("h3", {
              children: renderedAccessibilityHeader
            })]
          })]
        })
      }), /*#__PURE__*/_jsx(View, {
        as: "div",
        paddingBlockEnd: "200",
        paddingInline: "200",
        marginBlockStart: "100",
        overflowY: "scroll",
        children: AssociationOptions
      })]
    })
  });
};
export const connectResolver = ConnectReferenceResolvers((resolvers, {
  selectedObjectTypeId,
  associationRecords
}) => {
  if (!selectedObjectTypeId || !associationRecords) {
    return {};
  }
  const {
    resolverFactory,
    resolversCache
  } = resolvers.CUSTOM_OBJECT();
  const selectedAssociationRecord = associationRecords.find(associationRecord => associationRecord.get('toObjectTypeId') === selectedObjectTypeId);
  const primaryDisplayLabelGetter = selectedAssociationRecord.get('primaryDisplayLabelGetter');
  const secondaryDisplayLabelGetter = selectedAssociationRecord.get('secondaryDisplayLabelGetter');
  const options = {
    formatterOptions: {
      getters: {
        getLabel: primaryDisplayLabelGetter,
        getDescription: secondaryDisplayLabelGetter
      }
    }
  };
  const CustomObjectResolver = resolverFactory(selectedObjectTypeId, options);
  const resolver = CustomObjectResolver(resolversCache);
  return {
    resolver
  };
});
export default connectResolver(UniversalAssociationsSelectSearchPane);